import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import Import from './components/ImportDetailContainer';
import { growlErrors } from '../../../utils/NotificationUtil';
import { Loading } from '../../../components/Loading';
import { withAccount } from '../../../components/AccountContext';
import { withGrowl } from '../../../components/GrowlNotifications';
import { growlShape, matchShape } from '../../../components/prop-types';

export const IMPORT_QUERY = gql`
  query($accountId: ID!, $importId: ID!) {
    account(id: $accountId) {
      id
      surveyImport(id: $importId) {
        fileName
        createdOn
        updatedOn
        messages
        status
        id
        surveyProject {
          id
          name
          surveyTemplate {
            id
            title
          }
        }
      }
    }
  }
`;

class ImportDetailContainer extends Component {
  render() {
    const { growl, match: { params }, currentAccount } = this.props;
    const variables = {
      importId: params.importId,
      accountId: currentAccount,
    };
    return (
      <Query
        query={IMPORT_QUERY}
        variables={variables}
      >
        {({
          loading, error, data,
        }) => {
          if (loading) {
            return <Loading />;
          }
          if (error) {
            growlErrors(growl, error);
            return `Error! ${error.message}`;
          }
          const { account } = data;
          return (
            <Import data={account} />
          );
        }}
      </Query>
    );
  }
}

ImportDetailContainer.propTypes = {
  growl: growlShape.isRequired,
  match: matchShape.isRequired,
  currentAccount: PropTypes.string.isRequired,
};

export default withAccount(
  withGrowl(
    withRouter(
      ImportDetailContainer,
    ),
  ),
);
